export default {
  buttons: {
    change_plan: 'Change plan',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_save_changes: 'Failed to save changes',
  },
};
